import React from 'react'

import {withRouter} from 'react-router-dom'
import {getEmail, getEmailHint} from 'utils/stringUtils'
import LogisterForm, {validations} from './LogisterForm'
import FormContainer from 'components/form/FormContainer'

function LogisterFormContainer(props) {
  const email = getEmail(props.history.location.search) || getEmailHint(window.location.search)

  return (
    <FormContainer {...props} data={{email}} validations={validations}>
      <LogisterForm t={props.t} theme={props.theme} getRegistrationLink={props.getRegistrationLink} />
    </FormContainer>
  )
}

export default withRouter(LogisterFormContainer)
